import { x, b, u, _ } from "./preact-core.js";
class ExpandCollapse extends x {
  constructor(props) {
    super(props);
    this.expander = b();
    this.input = b();
    this.state = {
      open: this.props.open,
      maxHeight: "0"
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ open: this.props.open }, () => {
        if (this.expander.current) {
          if (this.state.open) {
            this.setState({
              maxHeight: `${this.expander.current.scrollHeight}px`
            });
          } else {
            this.setState({ maxHeight: `0` });
          }
          this.forceUpdate;
          if (this.input.current) {
            if (this.props.open) {
              this.input.current.focus();
            } else {
              this.input.current.blur();
            }
          }
        }
      });
    }
  }
  render() {
    return /* @__PURE__ */ u(
      "div",
      {
        class: "expander",
        style: `max-height:${this.state.maxHeight}`,
        ref: this.expander,
        children: /* @__PURE__ */ u("div", { class: "expander__content", children: [
          this.props.searchEnabled && /* @__PURE__ */ u("div", { class: "expander__search", children: /* @__PURE__ */ u(
            "input",
            {
              type: "text",
              ref: this.input,
              onInput: (e) => {
                this.props.searchCallback(e.currentTarget.value);
              },
              class: "w-full border-b-1 bg-transparent px-10 py-5"
            }
          ) }),
          this.props.children
        ] })
      }
    );
  }
}
const SvgSelectChevron = (props) => /* @__PURE__ */ _("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ _("g", { id: "Content" }, /* @__PURE__ */ _("path", { id: "Chevron", d: "M9 0.500031L5 4.50003L1 0.50003", stroke: "currentColor", strokeWidth: 0.86 })));
class CustomSelect extends x {
  constructor(props) {
    super(props);
    this.comparePropArrays = (a, b2) => {
      return JSON.stringify(a) === JSON.stringify(b2);
    };
    this.handleTrigger = () => {
      this.setState({ isOpen: !this.state.isOpen });
    };
    this.open = () => {
      this.setState({ isOpen: true });
    };
    this.close = () => {
      this.setState({ isOpen: false });
    };
    this.searchChildren = (value) => {
      this.setState({ search: value });
    };
    this.getLocaleFlag = (option) => {
      return /* @__PURE__ */ u("span", { class: "custom-dropdown__flag", children: /* @__PURE__ */ u(
        "img",
        {
          src: `//cdn.shopify.com/static/images/flags/${option.toLowerCase()}.svg?width=32`,
          alt: option
        }
      ) });
    };
    this.formatOptions = () => {
      var _a;
      return (_a = this.props.options) == null ? void 0 : _a.map((option, index) => {
        var _a2, _b;
        let optionClasses = "";
        ((_a2 = this.state.selected) == null ? void 0 : _a2.value) == option.value ? optionClasses += "--active" : null;
        (option == null ? void 0 : option.available) == false ? optionClasses += "--unavailable" : null;
        return ((_b = this.state.selected) == null ? void 0 : _b.value) != option.value && option.label.toLowerCase().includes(this.state.search.toLocaleLowerCase()) ? /* @__PURE__ */ u(
          "div",
          {
            class: `custom-select__option ${optionClasses}`,
            onClick: () => {
              this.handleSelect(option);
            },
            children: [
              this.getColor(option),
              this.props.type == "locale" && option.value ? this.getLocaleFlag(option.value) : null,
              /* @__PURE__ */ u("span", { children: [
                " ",
                option.label,
                " "
              ] })
            ]
          },
          `${option.id}-${index}`
        ) : null;
      });
    };
    this.handleSelect = (option) => {
      this.setState({ selected: option, isOpen: false }, () => {
        if (this.props.onSelected) {
          this.props.onSelected({
            id: this.props.title,
            value: this.state.selected
          });
        }
      });
    };
    this.state = {
      isOpen: false,
      isAnimating: false,
      selected: this.props.default ? this.props.default : null,
      search: ""
    };
  }
  componentDidUpdate(previousProps) {
    if (!this.comparePropArrays(previousProps.options, this.props.options)) {
      this.handleSelect(null);
    }
  }
  getColor(option) {
    if (!option) return;
    return option.color != void 0 || option.image != void 0 ? /* @__PURE__ */ u(
      "span",
      {
        class: "custom-select__option-swatch inline-block h-[15px] w-[45px]",
        style: { background: option.color ? option.color : "" },
        children: option.image && option.image != "" ? /* @__PURE__ */ u(
          "img",
          {
            src: option.image,
            alt: option.label,
            class: "h-full w-full object-cover",
            width: "45",
            height: "15"
          }
        ) : null
      }
    ) : "";
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    return /* @__PURE__ */ u(
      "div",
      {
        class: `custom-select-wrap ${this.props.type} `,
        onMouseLeave: () => {
          this.setState({ isOpen: false });
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            class: `custom-select ${this.state.isOpen ? "isOpen" : ""} ${this.props.options && ((_a = this.props.options) == null ? void 0 : _a.length) == 1 ? "limited" : null}`,
            children: [
              /* @__PURE__ */ u(
                "button",
                {
                  type: "button",
                  class: "custom-select__selected",
                  onClick: this.handleTrigger,
                  children: [
                    this.getColor(this.state.selected),
                    this.props.type == "locale" && ((_b = this.state.selected) == null ? void 0 : _b.value) ? this.getLocaleFlag((_c = this.state.selected) == null ? void 0 : _c.value) : null,
                    /* @__PURE__ */ u("span", { "data-selected-id": (_d = this.state.selected) == null ? void 0 : _d.id, children: this.state.selected ? this.state.selected.label : this.props.title }),
                    ((_e = this.props.options) == null ? void 0 : _e.length) > 0 ? /* @__PURE__ */ u("div", { class: "chevron-wrap absolute", children: /* @__PURE__ */ u(SvgSelectChevron, {}) }) : null
                  ]
                }
              ),
              ((_f = this.props.options) == null ? void 0 : _f.length) > 0 ? /* @__PURE__ */ u("div", { class: `custom-select__options-wrap ${this.props.direction}`, children: /* @__PURE__ */ u(
                ExpandCollapse,
                {
                  open: this.state.isOpen,
                  searchEnabled: this.props.searchEnabled,
                  searchCallback: this.searchChildren,
                  children: this.formatOptions()
                }
              ) }) : ""
            ]
          }
        )
      }
    );
  }
}
export {
  CustomSelect as C
};
